import default_avatar_male from "../../../../../../assets/default_male.svg";
import default_avatar_female from "../../../../../../assets/default_female.svg";
import default_avatar_neutral from "../../../../../../assets/default.svg";

interface AvatarProps {
  gender?: 'MALE' | 'FEMALE' | 'UNKNOWN' | string;
}

const Avatar = ({ gender }: AvatarProps): string => {
  let avatarSrc: string;

  switch (gender) {
    case 'MALE':
      avatarSrc = default_avatar_male;
      break;
    case 'FEMALE':
      avatarSrc = default_avatar_female;
      break;
    case 'UNKNOWN':
      avatarSrc = default_avatar_neutral;
      break;
    default:
      avatarSrc = default_avatar_neutral;
      break;
  }

  return avatarSrc;
};

export default Avatar;
